import fetchService from "../../../services/fetchService";
import { FETCH_SUBSCRIPTION } from "../types";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchSubscribers = (page) => async (dispatch) =>
  await dispatch({
    type: FETCH_SUBSCRIPTION,
    message: `All Wesite Suscribers`,
    payload: fetchService(`${baseUrl.backend}/api/subscribers?page=${page}&limit=10`),
  });
